import { Dropdown } from 'antd'
import Button from 'components/Button'
import Flex from 'components/Flex'
import RoutePath from 'components/RoutePath'
import ArrowLeftClick from 'components/icons/ArrowLeftClick'
import ArrowRightClick from 'components/icons/ArrowRightClick'
import LeftArrow from 'components/icons/LeftArrow'
import { format } from 'date-fns'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import {
  Container,
  DateClickText,
  LeftSection,
  RightSection,
  SectionName,
  TopHeading,
  CustomDiv,
  CustomSpan
} from './style'
import {
    TabCount,
} from 'modules/Drive/Partials/DriveTabs/Style/style'

const Header = ({
  currentStep,
  handlePrevWeek,
  toggleMiniCalendar,
  menu,
  showMiniCalendar,
  formattedListDate,
  handleNextWeek,
  currentWeekStart,
  currentWeekEnd,
  state,
  handleDraftChange,
  handleDraftRemove,
  draftCount
}) => {
  const navigate = useNavigate()
  const handleAddRole = () => {
    navigate('/events/newevent')
  }

  const draftEvent = state.eventStatus == 'DRAFT'
  return (

      <Container spaceBetween>
        <LeftSection centerVertically gap={draftEvent ? '20px' : '0px'}>
          <CustomDiv
            onClick={() => handleDraftRemove()}
          >
            {draftEvent ? <LeftArrow /> : null}
          </CustomDiv>
          <SectionName column>
            <RoutePath from="Events" path="/events" />
            <TopHeading>{draftEvent ? 'Drafts' : 'Overview'}</TopHeading>
            {draftEvent ? null : (
              <Flex
                row
                style={{
                  width: '100%',
                  position: 'relative',
                }}
                id="calendardetails"
              >
                <CustomSpan onClick={handlePrevWeek}>
                  <ArrowLeftClick />
                </CustomSpan>
                <Dropdown
                  onClick={toggleMiniCalendar}
                  trigger={['click']}
                  overlay={menu}
                  visible={showMiniCalendar}
                  getPopupContainer={() =>
                    document.getElementById('calendardetails')
                  }
                >
                  <span>
                    <DateClickText>
                      <DateClickText>
                        {state.currentToggle == 'left'
                          ? formattedListDate
                          : format(currentWeekStart, 'd MMM') +
                            '—' +
                            format(currentWeekEnd, 'd MMM, yyyy')}
                      </DateClickText>
                    </DateClickText>
                  </span>
                </Dropdown>
                <CustomSpan onClick={handleNextWeek}>
                  <ArrowRightClick />
                </CustomSpan>
              </Flex>
            )}
          </SectionName>
        </LeftSection>
        <RightSection>
          {draftEvent ? null : (
            <Button.Secondary text={<div style={{ display: 'flex', alignItems: 'center' }}>Show Drafts &nbsp;&nbsp;<TabCount>{draftCount}</TabCount></div> } onClick={handleDraftChange} disable={draftCount === 0} />
          )}
          <Button.Primary
            text={currentStep == 3 ? 'Submit' : 'Add New Event'}
            onClick={handleAddRole}
          />
        </RightSection>
      </Container>

 
  )
}

export default Header
